import axios from 'axios'

var qs = require('qs');
var root = process.env.API_ROOT


export const getListData = (params) => {
  return axios.post(root + '/warehouse/jxcstoreformdetail/getStoreFormDetailCount', qs.stringify(params))
}

//获取供应商列表
export const getListSupply = (params) => {
  return axios.post(root + '/order/cstagreement/getListSupply', qs.stringify(params))
}

//获取客户商列表
export const getListCustomer = (params) => {
  return axios.post(root + '/order/cstagreement/getListCustomer', qs.stringify(params))
}
export const productCost=(params) => {
  return axios.post(root + '/order/jiesuan/productCost', qs.stringify(params))
}
export const productCostlist=(params) => {
  return axios.post(root + '/order/jiesuan/productCostlist', qs.stringify(params))
}
//经销商统计页面
export const servicesub = (params) => {
  return axios.post(root + '/order/jiesuan/servicesub', qs.stringify(params))
}
//客户统计页面
export const customersub = (params) => {
  return axios.post(root + '/order/jiesuan/customersub', qs.stringify(params))
}

export const salecommission = (params) => {
  return axios.post(root + '/order/jiesuan/salecommission', qs.stringify(params))
}
//客户查看页面
export const customerSee = (params) => {
  return axios.post(root + '/order/jiesuan/customerSee', qs.stringify(params))
}
//经销商查看页面
export const distributorSee = (params) => {
  return axios.post(root + '/order/jiesuan/distributorSee', qs.stringify(params))
}


//供应商结算查看页面
export const supplierDeptSub = (params) => {
  return axios.post(root + '/order/jiesuan/supplierDeptSub', qs.stringify(params))
}
export const serviceList4Load = (params) => {
  return axios.post(root + '/order/jiesuan/serviceList4Load', qs.stringify(params))
}
//供应商对账产品
export const supplierseedcodeList = (params) => {
  return axios.post(root + '/order/jiesuan/supplierseedcodeList', qs.stringify(params))
}
//供应商结算明细查看页面
export const supplierDeptList = (params) => {
  return axios.post(root + '/order/jiesuan/supplierDeptList', qs.stringify(params))
}

export const supplierComputePrice = (params) => {
  let config = {
    timeout: 1000 * 60 * 2
  };
  return axios.post(root + '/order/jiesuan/supplierComputePrice', qs.stringify(params),config)
}

//微信退款
export const aLiRefund = (params) => {
  return axios.post(root + '/recharge/rechargerecord/aLiRefund', qs.stringify(params))
}

//充值统计
export const getRechargeCount = (params) => {
  return axios.post(root + '/order/jiesuan/getRechargeCount', qs.stringify(params))
}

//某个服务商的充值记录
export const getRechargerecord = (params) => {
  return axios.post(root + '/order/jiesuan/getRechargerecord', qs.stringify(params))
}

//某个服务商的余额消费记录
export const getBalabcerecord = (params) => {
  return axios.post(root + '/order/jiesuan/getBalabcerecord', qs.stringify(params))
}

//某个服务商的优惠券购买记录
export const getCouponrecord = (params) => {
  return axios.post(root + '/order/jiesuan/getCouponrecord', qs.stringify(params))
}

//商品统计页面
export const productAccounting = (params) => {
  return axios.post(root + '/order/jiesuan/productAccounting', qs.stringify(params))
}


//商品统计页面明细
export const productAccountlist = (params) => {
  return axios.post(root + '/order/jiesuan/productAccountlist', qs.stringify(params))
}

//对账记录保存
export const savetobalanceaccountlog = (params) => {
  return axios.post(root + '/order/balanceaccountlog/save', qs.stringify(params))
}

//获取对账记录
export const getbalanceaccountlog = (params) => {
  return axios.post(root + '/order/balanceaccountlog/list', qs.stringify(params))
}
//付款方式
export const settingmenthodList = (params) => {
  return axios.post(root + '/order/jiesuan/settingmenthodList', qs.stringify(params))
}
//客户结算查看
export const customerSettlement = (params) => {
  return axios.post(root + '/order/jiesuan/customerSettlement', qs.stringify(params))
}
//客户统计页面
export const tradersSub = (params) => {
  return axios.post(root + '/order/jiesuan/tradersSub', qs.stringify(params))
}

//铺货统计
export const puHuoList = (params) => {
  return axios.post(root + '/order/jiesuan/puHuoList', qs.stringify(params))
}

//调整时添加到记录表
export const changeAdjust = (params) => {
  return axios.post(root + '/order/jiesuan/changeAdjust', qs.stringify(params))
}
//铺货统计
export const puhuoSub = (params) => {
  return axios.post(root + '/order/jiesuan/puhuoSub', qs.stringify(params),)
}
//铺货修改的历史记录
export const listAdjust = (params) => {
  return axios.post(root + '/order/jiesuan/listAdjust', qs.stringify(params))
}



// WEBPACK FOOTER //
// ./src/api/set/jiesuan.js